export default __webpack_public_path__ + "static/media/createSurvey.49183a46.png";